import { defineNuxtPlugin } from '#app/nuxt'
import { LazyImageLoading, LazyMemberCard, LazyTypewriter } from '#components'
const lazyGlobalComponents = [
  ["ImageLoading", LazyImageLoading],
["MemberCard", LazyMemberCard],
["Typewriter", LazyTypewriter],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
